import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";
import { userStatsSchema } from "../user";
import { paymentStatsSchema } from "../payment/payment-stats";
import { souscriptionStatsSchema } from "../souscription/souscription-stats";
import { resumeStatsSchema } from "../resume/resume-stats";

const quantityAggregateSchema = z.object({
  currentQuantity: z.number(),
  previousQuantity: z.number().optional(),
  variation: z.number().optional(),
});

export class QuantityAggregateDto extends createZodDto(quantityAggregateSchema) {}

// analytics.dto.ts

export const dashboardMetricsSchema = z.object({
  users: userStatsSchema,
  payments: paymentStatsSchema,
  souscriptions: souscriptionStatsSchema,
  resumes: resumeStatsSchema,
  downloads: z.object({
    total: z.number(),
  }),
  credits: z.object({
    totalRemaining: z.number(),
    totalDistributed: z.number(),
  }),
  references: z.object({
    total: z.number(),
    bonusTotal: z.number(),
  }),
});

export class DashboardMetricsDto extends createZodDto(dashboardMetricsSchema) {}
